const mesuresAdapteesValueGetter = (params) => (params.data.util_sess_adapt === 1 ? "Oui" : "");

export default mesuresAdapteesValueGetter;